export default "__VITE_ASSET__CBRPoSbs__"